import { render, staticRenderFns } from "./table-cell.vue?vue&type=template&id=2cc3f1e6&"
import script from "./table-cell.vue?vue&type=script&lang=js&"
export * from "./table-cell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports